import React, { forwardRef } from 'react';
import { styleIcon } from '../style_icon.js';
export const ResetIcon = forwardRef(({ title = 'Reset Icon', ...rest }, ref) => {
    const props = styleIcon(rest);
    return (React.createElement("svg", { ...props, ref: ref, viewBox: "0 0 15 15" },
        !props['aria-hidden'] && React.createElement("title", null, title),
        React.createElement("path", { d: "M14.82 6.4a6.8 6.8 0 0 0-2.17-3.62 7 7 0 0 0-9.07-.2L1.44.44C1.14.14.71.22.68.58L.25 6.6c-.03.32.3.65.62.63L6.9 6.8c.36-.02.44-.46.14-.76L5 4a5 5 0 1 1 3.47 8.98.5.5 0 0 0-.47.5v1c0 .28.24.52.52.5a7.02 7.02 0 0 0 6.3-8.59" })));
});
//# sourceMappingURL=reset_icon.js.map